import { ApiError } from '@core/models';
import { createAction, props } from '@ngrx/store';

export enum GoogleApiActionTypes {
  LOAD_GOOGLE_MAPS_API = '[GoogleMapsApi] Load Google Maps API',
  LOAD_GOOGLE_MAPS_API_SUCCESS = '[GoogleMapsApi] Load Google Maps API Success',
  LOAD_GOOGLE_MAPS_API_FAILURE = '[GoogleMapsApi] Load Google Maps API Failure',
}

export const loadGoogleMapsApi = createAction(
  GoogleApiActionTypes.LOAD_GOOGLE_MAPS_API,
  // no props
);
export const loadGoogleMapsApiSuccess = createAction(
  GoogleApiActionTypes.LOAD_GOOGLE_MAPS_API_SUCCESS,
  // no props
);
export const loadGoogleMapsApiFailure = createAction(
  GoogleApiActionTypes.LOAD_GOOGLE_MAPS_API_FAILURE,
  props<ApiError>(),
);
